import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import axios from "axios";
import { Users, CheckCircle, XCircle, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function JoinTeamPage() {
  const { token } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | success | error | login_required
  const [message, setMessage] = useState("");
  const [teamName, setTeamName] = useState("");

  useEffect(() => {
    if (!user) {
      setStatus("login_required");
      return;
    }
    const join = async () => {
      try {
        const { data } = await axios.post(`${API}/teams/join/${token}`);
        setTeamName(data.team_name);
        setStatus("success");
        setTimeout(() => navigate("/dashboard"), 3000);
      } catch (err) {
        setMessage(err.response?.data?.detail || "Failed to join team");
        setStatus("error");
      }
    };
    join();
  }, [user, token, navigate]);

  return (
    <div className="min-h-screen bg-[#F8F9FC] flex items-center justify-center">
      <div className="bg-white rounded-2xl border border-slate-200 p-8 max-w-md w-full text-center">
        {status === "loading" && (
          <>
            <Loader2 size={40} className="mx-auto text-orange-500 animate-spin mb-4" />
            <p className="text-slate-600">Joining team...</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle size={48} className="mx-auto text-emerald-500 mb-4" />
            <h2 className="text-xl font-bold text-slate-800 mb-2">Welcome to {teamName}!</h2>
            <p className="text-sm text-slate-500">You've successfully joined the team. Redirecting to dashboard...</p>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle size={48} className="mx-auto text-red-400 mb-4" />
            <h2 className="text-xl font-bold text-slate-800 mb-2">Could not join team</h2>
            <p className="text-sm text-red-500 mb-4">{message}</p>
            <button onClick={() => navigate("/dashboard")} className="text-sm text-orange-600 hover:underline">Go to dashboard</button>
          </>
        )}
        {status === "login_required" && (
          <>
            <Users size={48} className="mx-auto text-orange-400 mb-4" />
            <h2 className="text-xl font-bold text-slate-800 mb-2">Log in to join team</h2>
            <p className="text-sm text-slate-500 mb-4">You need to log in or create an account first, then use this link again.</p>
            <button onClick={() => navigate("/login")} className="px-6 py-2 bg-orange-500 text-white text-sm font-medium rounded-lg hover:bg-orange-600 transition-colors">
              Log in
            </button>
          </>
        )}
      </div>
    </div>
  );
}
